module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bx85H"))).then(() => parcelRequire('d0iPb'));